class SwiperCarousel extends HTMLElement {
    constructor() {
      super();

      this.id = this.dataset.id;
      this.swiperEl = this.querySelector(`.swiper-carousel`);
      this._initSwiper = this._initSwiper.bind(this);
      this._setupSwiperLoadingLogic();
      this.fullWidth = this.dataset.fullWidth === "true";
    }

    _loadSwiperOnVisible = () => {
      const isAboveFold = this.getBoundingClientRect().top < window.innerHeight;

      if (isAboveFold) {
        window.swiperLoader.initImmediately(this._initSwiper);
      } else {
        const viewportHeight = window.innerHeight;
        window.swiperLoader.initWhenVisible(this, this._initSwiper, {
          rootMargin: `${viewportHeight}px`,
          threshold: 0.1,
        });
      }
    };

    _setupSwiperLoadingLogic() {
      if (!this.swiperEl) return;
  
      if (window.swiperLoader) {
        this._loadSwiperOnVisible();
      } else {
        window.addEventListener("swiperloader:ready", this._loadSwiperOnVisible, { once: true });
      }
    }
  
    _initSwiper(Swiper) {
      if (!Swiper) return;
  
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
  
      const swiperId = "swiper-carousel-" + this.id;
      const arrowLeft = this.querySelector(".swiper-button-prev");
      const arrowRight = this.querySelector(".swiper-button-next");
      if (arrowLeft && arrowRight) {
        arrowLeft.classList.add(`${swiperId}-arrow-left`);
        arrowRight.classList.add(`${swiperId}-arrow-right`);
      }
      this.swiperEl.classList.add(swiperId);
      const config = {
        slidesPerView: 1.5,
        centeredSlides: false,
        loop: false,
        infinite: false,
        spaceBetween: 0,
        setWrapperSize: true,
        breakpoints: {
          320: {
            slidesPerView: 1.5,
            slidesPerGroup: 1,
          },
          768: {
            slidesPerView: 2.5,
            slidesPerGroup: 2,
          },
          940: {
            slidesPerView: 3.5,
            slidesPerGroup: 3,
          },
          1200: {
            slidesPerView: 4.5,
            slidesPerGroup: 4,
          },
          1600: {
            slidesPerView: 5.5,
            slidesPerGroup: 6,
          },
        },
        navigation: {
          nextEl: `.${swiperId}-arrow-right`,
          prevEl: `.${swiperId}-arrow-left`,
        }
      };
      this.swiper = new Swiper(`.${swiperId}`, config);
  
      const slides = this.swiper.slides;
      if (!slides || slides.length === 0) return;
      const biggestHeight = Math.max(
        ...slides.map((s) => s.offsetHeight)
      );
      //create a css variable for the height
      this.style.setProperty("--slides-height", `${biggestHeight}px`);

      if (!this.fullWidth) {
        const carouselMargin = this.swiperEl.querySelector('.container').offsetLeft;
        const swiperWrapper = this.swiperEl.querySelector('.swiper-wrapper');
        swiperWrapper.firstElementChild.style.setProperty("margin-left", `${carouselMargin}px`);
        setTimeout(() => {
        swiperWrapper.querySelectorAll('.swiper-slide').forEach(slide => {
            slide === swiperWrapper.lastElementChild ? slide.style.setProperty("margin-right", `${carouselMargin}px`) : slide.style.setProperty("margin-right", `0px`);
          });
        }, 1000);
      }

    }
  }
  
  customElements.define("swiper-carousel", SwiperCarousel);
  